var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBankTouchpointAndCustomerCareOnlineAdvice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-3498.000000, -772.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bank-touchpoint-and-customer-care/Online-advice",
    transform: "translate(3498.000000, 772.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.00100667,12 C9.90005933,12 16.304102,18.403 16.304102,26.303 L16.304102,26.303 L16.304102,32 L1,32 L1,12 Z M31,13.8179 L31,28.3569 L19.9999267,28.3569 L19.9999267,24.0979 C19.9999267,18.4209 24.6019573,13.8179 30.2799952,13.8179 L30.2799952,13.8179 L31,13.8179 Z M26.4874699,2.9997 C28.7354849,2.9997 30.557497,4.8217 30.557497,7.0697 C30.557497,9.3177 28.7354849,11.1397 26.4874699,11.1397 C24.2394549,11.1397 22.4174428,9.3177 22.4174428,7.0697 C22.4174428,4.8217 24.2394549,2.9997 26.4874699,2.9997 Z M8.99955333,0 C11.7615717,0 13.9995867,2.238 13.9995867,5 C13.9995867,7.761 11.7615717,10 8.99955333,10 C6.23853492,10 3.99952,7.761 3.99952,5 C3.99952,2.238 6.23853492,0 8.99955333,0 Z",
    id: 115
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankTouchpointAndCustomerCareOnlineAdvice);
export default __webpack_public_path__ + "static/media/bank-touchpoint-and-customer-care-online-advice.466fa68b.svg";
export { ForwardRef as ReactComponent };